const BADGE_COLORS = 'none';
const TOOLTIP_COLORS = 'gray';
const TOOLTIP_POSITIONS = 'auto';

export { BADGE_COLORS as B, TOOLTIP_POSITIONS as T, TOOLTIP_COLORS as a };
